<!-- 资料变更历史 -->
<template>
    <div class='page_content'>
        <processAuditAction ref="processAuditAction"></processAuditAction>
        <div class="page_content_top">
             <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"  :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="formList.dataChangeHistory.length > 0" :flagList="['gchmState', 'gchmType']"
                    :searchList="formList.dataChangeHistory" :getRequestData="getRequestData" @searchData="searchData"
                    @openSearch="openSearch">
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-select v-if="formOneValue.entityField == 'gchmState'" v-model="getRequestData.gchmState"
                            size="mini" clearable>
                            <el-option
                                v-for="(values) in [{ key: 0, value: '初始' }, { key: -1, value: '审核退回' }, { key: 1, value: '提交审核' }, { key: 2, value: '审核通过' }]"
                                :label="values.value" :key="values.value" :value="values.key"></el-option>
                        </el-select>
                        <el-radio-group v-if="formOneValue.entityField == 'gchmType'" v-model="getRequestData.gchmType"
                            size="mini">
                            <el-radio-button label="">全部</el-radio-button>
                            <el-radio-button v-for="(values, keys) in $store.state.dataChangeTypeX" :label="values.id"
                                :key="keys">{{ values.name }}</el-radio-button>
                        </el-radio-group>
                    </template>
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum"
                border style="width: 100%" highlight-current-row>
                <el-table-column align="center" label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="gchmId" label="编号" show-overflow-tooltip width="130">
               <template slot-scope="scope">
                  <a @click="toDetail(scope.row.gchmId)">{{ scope.row.gchmId}}</a>
               </template>
            </el-table-column>
                <el-table-column align="center" prop="depName" label="申请部门" show-overflow-tooltip width="100">
                </el-table-column>
                <el-table-column align="center" prop="opmName" label="申请人员" show-overflow-tooltip width="100">
                </el-table-column>
                <el-table-column align="center" prop="chanCode" label="业务编码" show-overflow-tooltip width="120"></el-table-column>
                <el-table-column align="center" prop="chanName" label="名称" show-overflow-tooltip width="150">
                </el-table-column>
                <el-table-column align="center" prop="gchmType" label="变更类别" show-overflow-tooltip width="100">
                    <template slot-scope="scope">
                        <div v-if="$store.state.dataChangeTypeX[scope.row.gchmType]">
                            {{ $store.state.dataChangeTypeX[scope.row.gchmType].name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="applyReason" label="申请原因" show-overflow-tooltip width="120">
                </el-table-column>
                <el-table-column align="center" prop="remark" label="修改备注" show-overflow-tooltip width="120">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip label="状态" prop="gchmState" min-width="100">
                    <template slot-scope="scope">
                        <el-tag size="mini">
                            {{
                                $common.getIsGsp('[{"key":0,"value":"初始"},{"key":-1,"value":"审核退回"},{"key":1,"value":"提交审核"},{"key":2,"value":"审核通过"}]',
                                    scope.row.gchmState) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip label="变更时间" prop="createTime"
                    min-width="120">
                    <template slot-scope="scope">
                        <span>
                            {{ $common.getLocalTime(scope.row['createTime']) }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" :parentSearchData="parentSearchData"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import formList from './licenseChangeJson.js'
import SearchScheme from "../../../byComponents/SearchScheme.vue";

export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme},
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                gchmType: '',
                page: 1,
                rows: 30,
                start: '',
                end: '',
                chanName: '',
                createrName: "",
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },

            buttonList: [],
            selectedDataIndex: 0,
            actionData: {},
            formList: formList,
            DialogVisible: false,
            seId: "",
            seTitle: "",
            seWidth: "",
            parentSearchData: {},
            sField: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'getRequestData.gchmType': {
            handler: function (newValue, oldValue) {
                this.searchData()
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: { isPenetrate }, //参数
               },
               "*"
            );
         }
      },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识ppamId
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        getPageInfo() {
            this.getDataList()
        },
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 4:
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: '请先选择您要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
                    this.$refs['processAuditAction'].openBox(0, dataInfo.gchmId)
                    break;
                case 5:
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: '请先选择您要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
                    this.$refs['processAuditAction'].openBox(1, dataInfo.gchmId)
                    break;
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getDataChangeHistory(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        var objs = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        for (const key in objs) {
            this.$set(this.getRequestData, key, objs[key])
        }
        this.getDataList()
        this.getButtonList()

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>